export enum FeedbackStatus {
  OPEN = 'open', // open
  ARCHIVED = 'closed', // closed
  REOPENED = 'reopened', // reopened
  QUEUED = 'queued', // queued
  IN_PROGRESS = 'in_progress', // in progress
  IN_COMPLETE = 'incomplete', // incomplete
}
